import produce from "immer";
import { SEND_EMAIL_SUCCESS, RESET_CONTACT_PAGE } from "../constants";

const initialState = {
  message: "",
};

const contextReducer = produce((draft = initialState, action) => {
  switch (action.type) {
    case SEND_EMAIL_SUCCESS:
      draft.message =
        "Votre demande a bien été transmise, elle sera traitée dans les plus bref délais. Pensez à vérifier votre boite mail (y compris vos spams)";
      break;
    case RESET_CONTACT_PAGE:
      draft.message = "";
      break;
    default:
      return draft;
  }
});

export default contextReducer;
